'use strict';

angular.module('ntmApp').factory('Report', ['$rootScope', 'GridControl', 'DefaultGridCustomizer', 'GroupingGridCustomizer', 'ExportOptionsCustomizer', 'ColumnPreferencesCustomizer', 'ReportPrintingService', 'ReportService', 'FlashService',
    function ($rootScope, GridControl, DefaultGridCustomizer, GroupingGridCustomizer, ExportOptionsCustomizer, ColumnPreferencesCustomizer, ReportPrintingService, ReportService, FlashService) {

    function Report($scope) {

        var self = this;

        self.load = function (searchParams, callback) {

            var loading = FlashService.Loading();

            self.info = angular.copy(searchParams);

            ReportService.GetReport(searchParams).then(function (result) {

                loading.dismiss();

                if (result.success) {

                    if(result.data.limitExceeded) {
                        callback(result.data.limitExceededMessage);
                        return;
                    }

                    DefaultGridCustomizer.buildOptions(result.data.columns, self.Grid.gridOptions);
                    ExportOptionsCustomizer.buildOptions(self.Grid.gridOptions);
                    ColumnPreferencesCustomizer.buildOptions(result.data.preferences, self.Grid.gridOptions);

                    if (result.data.gridOptions) {
                        var options = angular.fromJson(result.data.gridOptions);

                        if (options && options.grouping && options.grouping.enable) {
                            GroupingGridCustomizer.buildOptions(options.grouping, self.Grid.gridOptions);
                            self.Grid.isGrouped = true;
                        }
                    }

                    self.Grid.applyData(result.data.grid);
                    self.Grid.handleWindowResize();

                    callback();
                } else {
                    callback("Can't build report");
                }
            });
        };

        self.generateSequence = function () {
            var reportTypes = {};

            $scope.reports.forEach(function (report) {

                if (report.selectedReport) {

                    if (!reportTypes[report.selectedReport.id]) {
                        reportTypes[report.selectedReport.id] = 0;
                    }

                    reportTypes[report.selectedReport.id]++;

                    report.sequenceId = reportTypes[report.selectedReport.id];
                }
            });
        };

        self.exportToPDF = function () {
          self.Grid.exportToPDF(self.info.reportName.includes('Report') ? self.info.reportName : (self.info.reportName+ ' Report'));
        };

        self.exportVisibleDataToPDF = function () {
          self.Grid.exportVisibleDataToPDF(self.info.reportName.includes('Report') ? self.info.reportName : (self.info.reportName + ' Report'));
        };

        function initialize() {

            self.Grid = new GridControl($scope, ReportPrintingService, DefaultGridCustomizer.getDefaultOptions());
            self.Grid.onColumnVisibilityChanged(function (columnPreferencesJson) {

                var request = {
                    reportId: self.info.reportId,
                    preferensesJson: columnPreferencesJson
                };

                ReportService.SavePreferences(request);

            });
        }

        initialize();
    }

    return (Report);
}]);
